/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AnalysePageWrapper_analyse_Posts$ref = any;
export type AnalysePageContainerQueryVariables = {|
  source_In?: ?$ReadOnlyArray<?string>,
  orderBy?: ?$ReadOnlyArray<?string>,
  searchTerms?: ?$ReadOnlyArray<?string>,
  filterTerms?: ?$ReadOnlyArray<?string>,
  selectedSentimentPostIds?: ?$ReadOnlyArray<?string>,
  allSubscriptions?: ?boolean,
|};
export type AnalysePageContainerQueryResponse = {|
  +selectedPosts: ?{|
    +$fragmentRefs: AnalysePageWrapper_analyse_Posts$ref
  |}
|};
export type AnalysePageContainerQuery = {|
  variables: AnalysePageContainerQueryVariables,
  response: AnalysePageContainerQueryResponse,
|};
*/


/*
query AnalysePageContainerQuery(
  $source_In: [ID]
  $orderBy: [String]
  $searchTerms: [String]
  $filterTerms: [String]
  $selectedSentimentPostIds: [ID]
  $allSubscriptions: Boolean
) {
  selectedPosts(source_In: $source_In, orderBy: $orderBy, searchTerms: $searchTerms, filterTerms: $filterTerms, selectedSentimentPostIds: $selectedSentimentPostIds, allSubscriptions: $allSubscriptions, first: 100) {
    ...AnalysePageWrapper_analyse_Posts
  }
}

fragment AnalysePageWrapper_analyse_Posts on PostNodeConnection {
  edges {
    node {
      id
      title
      created
      body
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "allSubscriptions"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterTerms"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchTerms"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "selectedSentimentPostIds"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "source_In"
},
v6 = [
  {
    "kind": "Variable",
    "name": "allSubscriptions",
    "variableName": "allSubscriptions"
  },
  {
    "kind": "Variable",
    "name": "filterTerms",
    "variableName": "filterTerms"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  },
  {
    "kind": "Variable",
    "name": "orderBy",
    "variableName": "orderBy"
  },
  {
    "kind": "Variable",
    "name": "searchTerms",
    "variableName": "searchTerms"
  },
  {
    "kind": "Variable",
    "name": "selectedSentimentPostIds",
    "variableName": "selectedSentimentPostIds"
  },
  {
    "kind": "Variable",
    "name": "source_In",
    "variableName": "source_In"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AnalysePageContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "PostNodeConnection",
        "kind": "LinkedField",
        "name": "selectedPosts",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AnalysePageWrapper_analyse_Posts"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AnalysePageContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v6/*: any*/),
        "concreteType": "PostNodeConnection",
        "kind": "LinkedField",
        "name": "selectedPosts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PostNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PostNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "created",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "body",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4659636a3b554c05d227ad0bcaf8e87a",
    "id": null,
    "metadata": {},
    "name": "AnalysePageContainerQuery",
    "operationKind": "query",
    "text": "query AnalysePageContainerQuery(\n  $source_In: [ID]\n  $orderBy: [String]\n  $searchTerms: [String]\n  $filterTerms: [String]\n  $selectedSentimentPostIds: [ID]\n  $allSubscriptions: Boolean\n) {\n  selectedPosts(source_In: $source_In, orderBy: $orderBy, searchTerms: $searchTerms, filterTerms: $filterTerms, selectedSentimentPostIds: $selectedSentimentPostIds, allSubscriptions: $allSubscriptions, first: 100) {\n    ...AnalysePageWrapper_analyse_Posts\n  }\n}\n\nfragment AnalysePageWrapper_analyse_Posts on PostNodeConnection {\n  edges {\n    node {\n      id\n      title\n      created\n      body\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4335b21fd2bec8185dee525d75bcf789';

module.exports = node;
